import { Card, CardContent } from "@learn-me/ui";
import { FadeIn } from "@/components/animated";
import { OfferingRequestForm } from "@/features/offerings/components/OfferingRequestForm";
import { Mail, Building2, GraduationCap } from "lucide-react";

const PATHS = [
  {
    icon: Building2,
    title: "Soluciones para empresas",
    description:
      "Plataformas personalizadas y rutas formativas construidas alrededor de su organización.",
  },
  {
    icon: GraduationCap,
    title: "Programas y capacitaciones",
    description:
      "Formación especializada, ajustable en contenidos, duración y modalidad.",
  },
  {
    icon: Mail,
    title: "Otra consulta",
    description:
      "Cuéntenos qué necesita y le orientamos sobre la mejor alternativa.",
  },
];

export default function ContactPage() {
  return (
    <div className="bg-white">
      <div className="container py-16 md:py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <FadeIn>
            <div>
              <h1 className="font-display text-4xl md:text-5xl font-bold text-secondary-900 mb-6">
                Cuéntenos qué necesita su organización
              </h1>
              <p className="text-lg text-secondary-600 leading-relaxed mb-10">
                Compártanos brevemente qué necesidad desea resolver y nuestro
                equipo se pondrá en contacto.
              </p>

              <div className="space-y-5">
                {PATHS.map((path) => {
                  const Icon = path.icon;
                  return (
                    <div key={path.title} className="flex gap-4">
                      <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                        <Icon className="h-5 w-5" />
                      </div>
                      <div>
                        <p className="font-semibold text-secondary-900">
                          {path.title}
                        </p>
                        <p className="text-sm text-secondary-600">
                          {path.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </FadeIn>

          <Card>
            <CardContent className="p-6 md:p-8">
              <OfferingRequestForm submitLabel="Enviar consulta" />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
